<dynamic-form
  #dynForm
  [controls]="controls"
  [isReadOnly]="isReadOnly"
  [separateByGroups]="separateByGroups"
  [separateGroupsByAccordion]="separateGroupsByAccordion"
  (formValidChange)="formValidChange($event)"
  (formDirtyChange)="formDirtyChange($event)"
  (onClickRaised)="onClickEvent()"
  (onDropdownChangeRaised)="onDropdownChange($event)"
  (formGroupCreated)="formGroupCreated.emit($event)"
>
</dynamic-form>
